import React__default from 'react';
import { useIsMounted__INTERNAL, useStytchB2BClient } from '../b2b/StytchB2BContext.mjs';
import { noProviderError } from '../utils/errors.mjs';
import { invariant } from '../utils/invariant.mjs';
import { AdminPortalSCIMContainer } from '../../../adminPortal/scim/AdminPortalSCIMContainer.mjs';

/**
 * The Admin Portal SCIM UI component.
 * This component must be rendered within a {@link StytchB2BProvider}.
 *
 * See the {@link https://stytch.com/docs/b2b/sdks/javascript-sdk online reference}
 */ const AdminPortalSCIM = (props)=>{
    invariant(useIsMounted__INTERNAL(), noProviderError('<AdminPortalMemberManagement />', 'StytchB2BProvider'));
    const stytchClient = useStytchB2BClient();
    return /*#__PURE__*/ React__default.createElement(AdminPortalSCIMContainer, {
        client: stytchClient,
        ...props
    });
};

export { AdminPortalSCIM };
//# sourceMappingURL=AdminPortalSCIM.mjs.map
